import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      // 1. Point to your existing backend API
      const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      
      // 2. Send the email to your backend so IT can securely ask Supabase for the reset link
      await axios.post(`${baseURL}/api/auth/forgot-password`, { email });

      // 3. Show success message
      setMessage('Password reset link sent! Please check your email.');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-950 to-slate-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 text-center">
        
        <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
          <span className="text-blue-600 text-2xl">🔒</span>
        </div>
        
        <h1 className="text-2xl font-bold text-slate-800 mb-2">
          Reset Password
        </h1>

        {message ? (
          <div className="mt-4">
            <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm mb-6">
              ✅ {message}
            </div>
            <Link to="/login" className="text-blue-600 font-medium hover:underline">
              Return to Login
            </Link>
          </div>
        ) : (
          <>
            <p className="text-slate-500 text-sm mb-6">
              Enter the email address associated with your account and we'll send you a link to reset your password.
            </p>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4 text-sm text-left">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4 text-left">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">
                  Email Address
                </label>
                <input 
                  type="email" 
                  required
                  className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="you@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)} 
                />
              </div>

              <button 
                type="submit" 
                disabled={loading}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2.5 rounded-lg transition disabled:opacity-50 mt-2">
                {loading ? 'Sending link...' : 'Send Reset Link'}
              </button>
            </form>

            <p className="text-center text-sm text-slate-500 mt-6">
              Remembered your password?{' '}
              <Link to="/login" className="text-blue-600 font-medium hover:underline">
                Sign in
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}